module.exports = __webpack_public_path__ + "static/media/step-two-big-.3f9dd19c.webp";